'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PaymentMethod = undefined;

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _reactIntl = require('react-intl');

var _antd = require('antd');

var _spacings = require('web-makeup/dist/design-system/styles/spacings');

var _layout = require('web-makeup/dist/styles/layout');

var _typography = require('web-makeup/dist/design-system/styles/typography');

var _auth = require('web-fns/dist/auth');

var _brandOrderHeader = require('../../components/brand-order-header/brand-order-header');

var _brandOrderHeader2 = _interopRequireDefault(_brandOrderHeader);

var _pageFooter = require('../../components/page-footer/page-footer');

var _pageFooter2 = _interopRequireDefault(_pageFooter);

var _layout2 = require('../../../styles/layout');

var _LoadingIndicator = require('./LoadingIndicator/LoadingIndicator');

var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);

var _InvoicePayment = require('./InvoicePayment/InvoicePayment');

var _InvoicePayment2 = _interopRequireDefault(_InvoicePayment);

var _ProjectInfo = require('./ProjectInfo/ProjectInfo');

var _ProjectInfo2 = _interopRequireDefault(_ProjectInfo);

var _PayPage = require('./PayPage.style');

var _mocks = require('./mocks');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var PaymentMethod = exports.PaymentMethod = undefined;
(function (PaymentMethod) {
    PaymentMethod[PaymentMethod["ACCOUNT"] = 0] = "ACCOUNT";
    PaymentMethod[PaymentMethod["OWNED_CARD"] = 1] = "OWNED_CARD";
    PaymentMethod[PaymentMethod["NEW_CARD"] = 2] = "NEW_CARD";
})(PaymentMethod || (exports.PaymentMethod = PaymentMethod = {}));
var PayPage = function PayPage() {
    var projectId = '003a8eb0-5349-4aa0-b08b-8c2abe9549e0';
    var currentUser = (0, _auth.getCurrentUser)();
    var _a = React.useState(PaymentMethod.NEW_CARD),
        paymentMethod = _a[0],
        setPaymentMethod = _a[1];
    var _b = React.useState(),
        selectedCardId = _b[0],
        setSelectedCardId = _b[1];
    var _c = React.useState(true),
        saveCard = _c[0],
        setSaveCard = _c[1];
    var isSubmitting = false;
    return React.createElement(React.Fragment, null, React.createElement(_brandOrderHeader2.default, { active: 1, isNotificationActive: true, showSubHeader: false }), isSubmitting && React.createElement(_LoadingIndicator2.default, null), !isSubmitting && React.createElement(_layout2.Content, { offsetTop: 10 }, React.createElement(_layout.OptionalFlex, { flex: true, alignHorizontally: "space-between", alignVertically: "flex-start", responsive: true }, React.createElement(_layout2.ContainerInner, null, React.createElement(_spacings.Padding, { top: true, bottom: true }, React.createElement(_PayPage.PayPageMainTitleWrapper, null, React.createElement(_antd.Row, { gutter: 36 }, React.createElement(_antd.Col, { lg: 14, span: 24 }, React.createElement(_typography.Text, { as: "h1", fontSize: "h0", fontWeight: "black", color: "coal", textAlign: "center" }, React.createElement(_reactIntl.FormattedMessage, { id: "Test pay page" })), React.createElement(_typography.Text, { as: "p", fontSize: "h3", color: "black1", textAlign: "center" }, React.createElement(_reactIntl.FormattedMessage, { id: "Pay page description" }))))), React.createElement(_PayPage.MainRow, { type: "flex", gutter: 36 }, React.createElement(_antd.Col, { lg: 14, span: 24 }, React.createElement(_PayPage.PayContainer, null, React.createElement(_ProjectInfo2.default, { project: _mocks.project, projectId: projectId }), React.createElement(_InvoicePayment2.default, { projectId: projectId, brandUuid: "123", totalPayment: _mocks.price, invoices: _mocks.invoices, canChargeToAccount: false, paymentMethod: paymentMethod, onPaymentMethodChanged: setPaymentMethod, invoiceEmail: currentUser.email, selectedCardId: selectedCardId, onSelectedCardIdChanged: setSelectedCardId, saveCard: saveCard, onSaveCardToogle: setSaveCard, onInvoicePaid: function onInvoicePaid() {
            return true;
        } })))))))), React.createElement(_pageFooter2.default, null));
};
exports.default = PayPage;
//# sourceMappingURL=PayPage.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/web-ui/dist/order/views/pay-page/PayPage.js
// module id = 581
// module chunks = 0